"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APClone = exports.APSizedBox = exports.APStrike = exports.APPadding = exports.APCenter = exports.APExpanded = exports.APIntrinsicHeight = void 0;
var react_1 = __importDefault(require("react"));
var APFlex_1 = require("./APFlex");
function APIntrinsicHeight(_a) {
    var children = _a.children, style = _a.style, mainAxisAlignment = _a.mainAxisAlignment, crossAxisAlignment = _a.crossAxisAlignment;
    return (react_1.default.createElement("div", { style: __assign({ display: "flex", flexDirection: "column", justifyContent: APFlex_1.getMainAxisAlignment(mainAxisAlignment), alignItems: APFlex_1.getCrossAxisAlignment(crossAxisAlignment) }, style) }, children));
}
exports.APIntrinsicHeight = APIntrinsicHeight;
function APExpanded(_a) {
    var _b = _a.flex, flex = _b === void 0 ? 1 : _b, children = _a.children, style = _a.style, _c = _a.noClone, noClone = _c === void 0 ? false : _c;
    return (react_1.default.createElement(APClone, { style: __assign(__assign({}, style), { flex: flex, minHeight: 0, minWidth: 0 }), noClone: noClone }, children));
}
exports.APExpanded = APExpanded;
function APCenter(props) {
    return (react_1.default.createElement("div", { style: __assign({ display: "grid", placeItems: "center", width: "100%", height: "100%" }, props.style) }, props.children));
}
exports.APCenter = APCenter;
function APPadding(_a) {
    var _b = _a.padding, padding = _b === void 0 ? "16px" : _b, margin = _a.margin, children = _a.children, style = _a.style, noClone = _a.noClone;
    return (react_1.default.createElement(APClone, { style: __assign(__assign({}, style), { padding: padding, margin: margin }), noClone: noClone }, children));
}
exports.APPadding = APPadding;
function APStrike(_a) {
    var strike = _a.strike, children = _a.children;
    if (strike) {
        return react_1.default.createElement("del", { style: { color: "#888" } }, children);
    }
    else {
        return children;
    }
}
exports.APStrike = APStrike;
function APSizedBox(props) {
    return (react_1.default.createElement(APClone, { noClone: props.noClone, style: __assign(__assign({}, props.style), { height: props.height, width: props.width, minHeight: props.height, minWidth: props.width, maxHeight: props.height, maxWidth: props.width }) }, props.children));
}
exports.APSizedBox = APSizedBox;
function APClone(props) {
    var _a, _b;
    if (props.children == null) {
        return react_1.default.createElement("div", { style: props.style });
    }
    if (props.noClone) {
        return react_1.default.createElement("div", { style: __assign(__assign({}, props.style), (_a = props.children) === null || _a === void 0 ? void 0 : _a.props.style) }, props.children);
    }
    var newStyle = __assign(__assign({}, props.style), (_b = props.children) === null || _b === void 0 ? void 0 : _b.props.style);
    return react_1.default.cloneElement(props.children, { style: newStyle });
}
exports.APClone = APClone;
